import { inject } from 'vue'
import { Step } from '../../domain'
import { logisticFormStepsSymbol } from './provideLogisticOfferFormSteps'

export const useLogisticOfferFormSteps = () => {
  return inject<Step[]>(logisticFormStepsSymbol)!
}
